const handleScreentest = {
  beforeMount() {
    this.$store.commit(
      'UPDATE_SCREENTEST',
      this.$route.query.screentest || process.env.VUE_APP_SCREENTEST
    );
  }
};

export default handleScreentest;
